@let cluster =
  clustersEc.plugins.currentEntityPlugin.feature.selectors
    .getEditedEntity()
    .asSignal();
@let updatedCluster =
  clustersEc.plugins.currentEntityPlugin.feature.selectors
    .getUpdatedEntity()
    .asSignal();
@let isCreating =
  clustersEc.plugins.currentEntityPlugin.feature.selectors
    .isCreating()
    .asSignal();
@let isSubmitting =
  clustersEc.plugins.editingPlugin.feature.selectors.isSubmitting.asSignal();

<atn-ds-centered-overlay type="narrow">
  <div class="atn-space-cluster-modal">
    <atn-ds-widget [title]="titleSg()">
      <div actions>
        <i
          class="atn-icon atn-close atn-red"
          (click)="cancelClickHandler()"
        ></i>
      </div>

      <div class="atn-space-cluster-modal__content">
        <div class="atn-space-cluster-modal__field">
          <atn-ds-text
            label="Name"
            [value]="cluster?.name ?? ''"
            (change)="updateCluster({ name: $event })"
          />
        </div>

        <div class="atn-space-cluster-modal__field">
          <atn-ds-text-area
            label="Description"
            [value]="cluster?.description ?? ''"
            (change)="updateCluster({ description: $event })"
            [styleOverrides]="{
              height: '100px',
              resize: 'vertical',
            }"
          />
        </div>

        @if (updatedCluster) {
          <div class="atn-space-cluster-modal__field">
            <atn-ds-text-area
              label="Comment"
              placeholder="Enter a comment"
              [value]="updatedCluster.comment ?? ''"
              (change)="updateCluster({ comment: $event })"
              [styleOverrides]="{
                height: '100px',
                resize: 'vertical',
              }"
            />
          </div>
        }

        @if (isCreating) {
          @let entities = organizationEntityOptionsSg();
          @for (entity of entities; track entity.id; let isRequired = $last) {
            <atn-ds-select-single
              [label]="entity.name"
              [items]="entity.options"
              [config]="{
                overlay: { minSearchCharacters: 1, hasSearch: true },
              }"
              [value]="selectionLookupSg()[entity.id]"
              (valueChange)="handleOrganizationSelection(entity.id, $event)"
              [required]="isRequired"
              placeholder="Select {{ entity.name.toLowerCase() }}"
            />
          }
        }
      </div>

      <div
        class="atn-space-cluster-modal__footer"
        footer
      >
        <atn-ds-button
          type="transparent"
          (click)="cancelClickHandler()"
          >Cancel</atn-ds-button
        >
        <atn-ds-button
          [disabled]="!canSaveSg()"
          [loading]="isSubmitting"
          (click)="saveClickHandler()"
          >Save</atn-ds-button
        >
      </div>
    </atn-ds-widget>
  </div>
</atn-ds-centered-overlay>
